import AnswerFreeTextGeneric from './AnswerFreeTextGeneric';
import AnswerPhoneNumber from './AnswerPhoneNumber';
import { FC } from 'react';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { observer } from 'mobx-react';

const componentMap: Record<string, typeof AnswerPhoneNumber> = {
  phoneNumber: AnswerPhoneNumber,
  videocallPhoneNumber: AnswerPhoneNumber,
};
const getSpecial = (question: SnapshotOrInstance<IQuestionModel>) => {
  return question.key
    ? componentMap[question.key as keyof typeof componentMap]
    : undefined;
};

export interface AnswerFreeTextProps {
  question:  SnapshotOrInstance<IQuestionModel>;
}

export const AnswerFreeText: FC<AnswerFreeTextProps> = ({
  question,
}, ref) => {

  const AnswerFreeTextSpecial = getSpecial(question);

  if (AnswerFreeTextSpecial) {
    return (
      <AnswerFreeTextSpecial
        question={question}
      />
    );
  }

  return (
    <AnswerFreeTextGeneric
      question={question}
    />
  );
};
export default observer(AnswerFreeText);
